import { apiFetch } from './client';
import { API_BASE_URL } from '../config';

export const listSongs = (token) => apiFetch(token, '/songs');

export const importSongs = (token, formData) =>
  apiFetch(token, '/songs/import', { method: 'POST', body: formData });

// The export is a binary .xlsx, not JSON, so it can't go through apiFetch (which
// always parses the response as JSON) — this fetches it as a blob and triggers a
// browser download directly, since the endpoint needs the admin's auth header and
// a plain <a href> download link can't attach one.
export async function downloadSongsExport(token) {
  let response;
  try {
    response = await fetch(`${API_BASE_URL}/songs/export`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  } catch (err) {
    throw new Error('Could not reach the server. Please check your connection and try again.');
  }

  if (!response.ok) {
    const data = await response.json().catch(() => null);
    const error = new Error(data?.detail ? String(data.detail) : `Request failed (${response.status})`);
    error.status = response.status;
    throw error;
  }

  const blob = await response.blob();
  const disposition = response.headers.get('Content-Disposition') || '';
  const match = disposition.match(/filename="?([^"]+)"?/);
  const filename = match ? match[1] : 'songs_export.xlsx';

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

export const createSong = (token, payload) =>
  apiFetch(token, '/songs', { method: 'POST', body: JSON.stringify(payload) });

export const updateSong = (token, songId, payload) =>
  apiFetch(token, `/songs/${songId}`, { method: 'PATCH', body: JSON.stringify(payload) });

export const deleteSong = (token, songId) =>
  apiFetch(token, `/songs/${songId}`, { method: 'DELETE' });
